export const API_BASE_URL = "https://kiddypalace.in";

